import React, { useState, useEffect } from "react";
import { Card, Title } from "@mantine/core";

import { OrganizationForm, OrganizationList } from "./";
import { ManagementLayout } from "@components/shared";

export default function OrganizationManagement() {
  const [success, setSuccess] = useState(false);
  const [refresh, setRefresh] = useState(false);

  return (
    <ManagementLayout
      dataComponent={<OrganizationList refresh={refresh} />}
      createComponent={
        <Card
          style={{
            overflow: "visible",
          }}
        >
          <Title order={4}>Create Organization</Title>
          {!success && (
            <OrganizationForm
              onSuccess={() => {
                setSuccess(!success);
                setRefresh(!refresh);
                setTimeout(() => {
                  setSuccess(false);
                }, 1);
              }}
            />
          )}
        </Card>
      }
    />
  );
}
